import React, { useState, useContext, useLayoutEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, TextField } from "@material-ui/core";
import { distinctUntilChanged, map } from "rxjs/operators";
import { Subject } from "rxjs";

import { TableContext } from "./TableContext";
import { TableActionTypes, ITableState } from "./interfaces";
import { Icon } from "../icons/Icon";

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: "center",
    display: "flex",
    marginRight: theme.spacing(1),
    minWidth: "160px"
  }
}));

export const SearchBar: React.FC = () => {
  const classes = useStyles();

  const [searchInput, setSearchInput] = useState("");

  const { dispatch, subscribe } = useContext(TableContext);

  useLayoutEffect(() => {
    const tableStateObserver$ = new Subject<ITableState>();
    const tableSubscription = tableStateObserver$
      .pipe(
        map(({ searchInput: inputString }) => inputString),
        distinctUntilChanged((next, prev) => next === prev)
      )
      .subscribe(inputString => {
        setSearchInput(inputString);
      });

    const subscription = subscribe(tableStateObserver$);

    return () => {
      tableStateObserver$.complete();
      subscription.unsubscribe();
      tableSubscription.unsubscribe();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={classes.root}>
      <TextField
        onChange={event => {
          dispatch({
            type: TableActionTypes.onSearch,
            payload: event.target.value
          });
        }}
        onKeyPress={event => {
          if (event.key === "Enter") {
            dispatch({
              type: TableActionTypes.search,
              payload: searchInput
            });
          }
        }}
        placeholder="Search"
        value={searchInput}
      />
      <IconButton
        onClick={() => {
          dispatch({
            type: TableActionTypes.search,
            payload: searchInput
          });
        }}
      >
        <Icon name="search" />
      </IconButton>
      <IconButton
        onClick={() => {
          dispatch({
            type: TableActionTypes.search,
            payload: ""
          });
        }}
      >
        <Icon name="close" />
      </IconButton>
    </div>
  );
};
